// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"60957":"e2745835eec2cb6b","74724":"b6323009d4472833","95868":"6438dbb375600f1b","96325":"72b2ee40f9982890"}[chunkId] + ".css";
};